import theme from '../config/theme';
import useMediaQuery from '@mui/material/useMediaQuery';

const ADAPTIVES = {
  tablet: theme.breakpoints.down('md'),
  mobile: theme.breakpoints.down('sm'),
};

export function useAdaptiveClassNameEffect(adaptive: keyof typeof ADAPTIVES) {
  const isNeedAddClassName = useMediaQuery(ADAPTIVES[adaptive]);

  return isNeedAddClassName ? 'uni-credit-' + adaptive : '';
}

export function useTabletClassNameEffect() {
  const mobileClassName = useAdaptiveClassNameEffect('tablet');

  return mobileClassName;
}

export function useMobileClassNameEffect() {
  const mobileClassName = useAdaptiveClassNameEffect('mobile');

  return mobileClassName;
}

export function useTabletEffect() {
  return useMediaQuery(ADAPTIVES.tablet);
}

export function useMobileEffect() {
  return useMediaQuery(ADAPTIVES.mobile);
}
